import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'common/lib/numeral'
import classNames from 'classnames'
import { first, last, map, filter, has, keyBy, find, reduce, forEach, sortBy } from 'lodash'
import { push } from 'react-router-redux'
import actions from 'client/actions'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import {styles} from 'common/lib/styles';
import { Typography } from '@material-ui/core';
import PartDialog from 'client/components/PartDialog';
import Button from '@material-ui/core/Button';
import PartItem from 'client/components/PartItem';
import Contact from 'client/components/Contact';
import ActivityTable from 'client/components/ActivityTable';

// const InspectionRow = ({ part, showPartHandler, classes }) => {
//   const { id, title } = part

//   return (
//     <TableRow className={classes.cursor} onClick={ showPartHandler(part.id, 'inspection') }>
//       <TableCell className={classes.underline}>{ part.title }</TableCell>
//       {/* <TableCell align="right">{ part.amount }</TableCell> */}
//     </TableRow>
//   )
// }
// InspectionRow.propTypes = {
//   part: PropTypes.object.isRequired,
//   showPartHandler: PropTypes.func.isRequired,
// }

// const ExtraordinaryRow = ({ part, showPartHandler }) => {
//   const { id, title } = part

//   return (
//     <tr>
//       <td><a onClick={ showPartHandler(part.id, 'maintenance') }>{ part.title }</a></td>
//       <td className="text-warning">{ numeral(part.establishment_cost).format('0,0') }</td>
//     </tr>
//   )
// }
// ExtraordinaryRow.propTypes = {
//   part: PropTypes.object.isRequired,
//   showPartHandler: PropTypes.func.isRequired,
// }

class ActivityPlan extends Component {

  static propTypes = {
    current_year: PropTypes.number.isRequired,
    years: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    estimates: PropTypes.object.isRequired,
    maintenance_parts: PropTypes.array.isRequired,
    inspection_parts_by_year: PropTypes.object.isRequired,
    parts: PropTypes.object.isRequired,
    plan: PropTypes.object.isRequired,
  }

  constructor (props) {
    super(props)
    this.toggleModal = this.toggleModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
    this.handleYearClick = this.handleYearClick.bind(this)
    this.state = {
      currentPartId: null,
      currentModalType: '',
      modalVisible: false,
      isYearOpen: false,
    }
  }

  componentDidMount() {
      const { dispatch, setBreadcrumb, params, current_year } = this.props
      dispatch(setBreadcrumb('Projektoversigt'));
  }

  handleYearClick (e) {
      e.preventDefault();
      this.setState({isYearOpen: !this.state.isYearOpen})
  }

  toggleModal (part_id, type) {
    return e => {
      this.setState({
        ...this.state,
        modalVisible: !this.state.modalVisible,
        currentPartId: part_id,
        currentModalType: type,
      })
    }
  }

  closeModal () {
    this.setState({
      ...this.state,
      modalVisible: !this.state.modalVisible,
    })
  }

  partLinkHandler (id) {
      const { dispatch, params } = this.props
      dispatch(push(`/c/${params.customer_id}/parts/${id}`))
  }

  render () {
    const {
      params: { customer_id }, plan, parts, classes, texts, projects, availableYears
    } = this.props

    const part = parts[this.state.currentPartId]
    const type = this.state.currentModalType

    const { modalVisible, currentPartId } = this.state

    return (
      <div>
        <Grid container spacing={3}>
            {availableYears.map(year => <ActivityTable year={year} customer_id={customer_id} toggleModal={this.toggleModal} />)}
            
            {/* {projects.length ? <Grid item sm={12} md={6}>
                <Paper className={classes.paper}>
                    <Typography className={classes.header} variant="h5">Opgaver der bør prioriteres</Typography>
                    <Typography component="div">
                        { projects.map(p => (
                            <PartItem
                                linkHandler={() => this.partLinkHandler(p.part.id)}
                                key={ p.id }
                                part={ p.part }
                                project={p}
                                prioritized={p.prioritized}
                                md={12}
                            />)) }
                    </Typography>
                </Paper>
            </Grid> : null} */}
            <Grid item sm={12} md={12}>
                <Paper className={classes.paper}>
                    <Typography variant="h5">Find inspiration til dine projekter herunder</Typography>
                    <div className={classes.paperButtons}>
                        <Button href="https://www.plan1.dk/tagrenovering" target="_blank" variant="outlined">Tag</Button>
                        <Button href="https://www.plan1.dk/facade" target="_blank" variant="outlined">Facade</Button>
                        <Button href="https://www.plan1.dk/vinduesrenovering" target="_blank" variant="outlined">Vinduer</Button>
                        <Button href="https://www.plan1.dk/vvs-og-ventilation" target="_blank" variant="outlined">VVS & Ventilation</Button>
                        <Button href="https://www.plan1.dk/trappeopgange" target="_blank" variant="outlined">Trappeopgange</Button>
                        <Button href="https://www.plan1.dk/baeredygtig-renovering" target="_blank" variant="outlined">Bæredygtighed</Button>
                    </div>
                </Paper>
            </Grid>
            <Grid item sm={12} md={6}>
                <Paper className={classes.paper}>
                    <Typography className={classes.header} variant="h5">Gode råd til dit forestående projekt</Typography>
                    <Typography>{texts.intro_content}</Typography>
                </Paper>
            </Grid>
            <Grid item sm={12} md={6}>
                {plan.internal_contact ? <Contact
                    title="Rådgiver fra Plan1"
                    name={plan.internal_contact.name}
                    email={plan.internal_contact.email}
                    phone={plan.internal_contact.phone}
                    src={plan.internal_contact.s3_image_id ? `https://ik.imagekit.io/aw3ddey5g/${plan.internal_contact.s3_image_id}?tr=w-200` : null}
                    variant="h5"
                    paperClasses={classes.paper}
                /> :  null}
            </Grid>
            {/* <Grid item sm={12} md={6}>
                <TableContainer component={Paper} className={classes.paper}>
                    <Typography className={`${classes.tablePadding} ${classes.header}`} variant="h5">
                        Eftersynsaktiviteter
                    </Typography>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                { inspectionHeaders.map((header, idx) => <TableCell align={idx == 1 ? "right" : "left"} key={ idx }>{ header }</TableCell>) }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { inspectionRows }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid> */}
        </Grid>
        <PartDialog type={type} part={part} closeModal={this.closeModal} customerId={customer_id} modalVisible={modalVisible} />
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const start_year = state.data.years.start_year
  const current_year = parseInt(props.params.activity_year || start_year, 10)
  const parts = keyBy(state.data.customer.parts, 'id')

  const projects = state.data.customer.projects.filter(p => p.year == current_year && p.show_in_list)

  let availableYears = [...new Set(state.data.customer.projects.filter(p => p.show_in_list).map(p => p.year))];
  availableYears = availableYears.length ? availableYears.sort((a, b) => a - b) : [current_year];

  return {
    current_year,
    availableYears,
    parts,
    plan: state.data.customer.plan,
    projects: projects,
    texts: state.data.customer.systemTexts,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setBreadcrumb: actions.setBreadcrumb,
    dispatch,
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(ActivityPlan))
